export const AirQuality = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1763_93)">
      <path
        d="M11.9987 15.0633C13.6918 15.0633 15.0644 13.6907 15.0644 11.9976C15.0644 10.3045 13.6918 8.93201 11.9987 8.93201C10.3056 8.93201 8.93311 10.3045 8.93311 11.9976C8.93311 13.6907 10.3056 15.0633 11.9987 15.0633Z"
        fill="#007BFF"
      />
      <path
        d="M23.639 11.0376C23.3076 10.1503 22.5473 9.40917 21.6145 9.07308C19.8571 8.43417 17.7989 8.60714 15.6084 9.52261C16.0918 10.2256 16.3587 11.0547 16.3762 11.9076C16.3937 12.7606 16.161 13.6 15.7068 14.3221C16.4859 14.598 17.1683 15.0938 17.6714 15.7494C18.1745 16.4051 18.4769 17.1925 18.5418 18.0164C18.5418 18.0164 18.5517 18.12 18.5493 18.3445C18.5472 18.6132 18.6261 18.8764 18.7757 19.0996C18.9553 19.3753 19.2351 19.5702 19.5558 19.6431C19.8766 19.716 20.2132 19.6611 20.4942 19.4901L20.519 19.4751C22.867 17.7707 24.8353 14.1164 23.639 11.0376Z"
        fill="#007BFF"
      />
      <path
        d="M7.62079 12C7.6198 11.1786 7.85121 10.3737 8.28829 9.67824C7.51037 9.40179 6.82914 8.90601 6.32688 8.25079C5.82463 7.59556 5.52284 6.80892 5.45798 5.98589C5.45798 5.98589 5.44813 5.8823 5.45048 5.65777C5.4526 5.38902 5.37371 5.12586 5.22407 4.90261C5.04455 4.62697 4.76475 4.43205 4.44398 4.35916C4.1232 4.28627 3.78665 4.34114 3.50563 4.51214L3.48079 4.52714C1.13282 6.23011 -0.83546 9.88449 0.36079 12.9646C0.692196 13.852 1.45251 14.5926 2.38532 14.9292C4.14267 15.5685 6.20141 15.3951 8.39235 14.4792C7.88883 13.7506 7.61965 12.8856 7.62079 12Z"
        fill="#007BFF"
      />
      <path
        d="M19.4872 3.50576L19.4727 3.48091C17.7693 1.13294 14.1154 -0.835338 11.0352 0.360912C10.1479 0.692318 9.40724 1.45263 9.07114 2.38544C8.43177 4.14232 8.60521 6.20013 9.51974 8.39013C10.2227 7.90606 11.0522 7.63851 11.9055 7.62052C12.7589 7.60252 13.5988 7.83488 14.3216 8.28888C14.5981 7.51084 15.0939 6.82949 15.7492 6.32715C16.4045 5.82481 17.1913 5.52297 18.0144 5.4581C18.0144 5.4581 18.118 5.44826 18.3425 5.4506C18.6113 5.45267 18.8744 5.37377 19.0977 5.22419C19.3732 5.04452 19.5679 4.76466 19.6406 4.44389C19.7133 4.12313 19.6583 3.78666 19.4872 3.50576Z"
        fill="#007BFF"
      />
      <path
        d="M11.9998 16.3758C11.178 16.3767 10.3727 16.145 9.67714 15.7073C9.40118 16.4863 8.90539 17.1686 8.24976 17.6716C7.59413 18.1747 6.80676 18.477 5.98292 18.5419C5.98292 18.5419 5.87933 18.5517 5.6548 18.5494C5.38619 18.5472 5.12319 18.6261 4.90011 18.7758C4.62446 18.9553 4.42955 19.2351 4.35666 19.5559C4.28377 19.8766 4.33864 20.2132 4.50964 20.4942L4.52417 20.519C6.22761 22.867 9.88151 24.8353 12.9617 23.639C13.849 23.3076 14.5896 22.5473 14.9262 21.6145C15.5651 19.8567 15.3917 17.7975 14.4757 15.6061C13.7477 16.1081 12.8841 16.3766 11.9998 16.3758Z"
        fill="#007BFF"
      />
    </g>
    <defs>
      <clipPath id="clip0_1763_93">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const DrainsSewer = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1763_62)">
      <path d="M2.09082 0H7.75311V2.12336H2.09082V0Z" fill="#007BFF" />
      <path
        d="M16.2466 4.2467H21.9089V8.49342H16.2466V4.2467Z"
        fill="#007BFF"
      />
      <path
        d="M0.675293 3.53894H9.16873V6.37009H0.675293V3.53894Z"
        fill="#007BFF"
      />
      <path d="M14.8311 0H23.3245V2.83115H14.8311V0Z" fill="#007BFF" />
      <path d="M14.8311 9.909H23.3245V12.7401H14.8311V9.909Z" fill="#007BFF" />
      <path
        d="M11.9998 18.4024C9.65819 18.4024 7.75311 16.4974 7.75311 14.1557V7.78564H2.09082V14.1557C2.58896 27.2842 21.4133 27.2786 21.9088 14.1557H16.2465C16.2465 16.4974 14.3415 18.4024 11.9998 18.4024Z"
        fill="#007BFF"
      />
    </g>
    <defs>
      <clipPath id="clip0_1763_62">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ElectricalInstallation = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.5 3.99998H18V3.50001C18 3.36722 17.9473 3.24023 17.8535 3.14648L16.8535 2.1465C16.7598 2.05275 16.6328 2.00001 16.5 2.00001H14.6182L12.7236 1.05276L12.7214 1.05726C12.6539 1.02337 12.5807 1.00003 12.5 1.00003H1.99997C0.896953 0.999984 0 1.89698 0 3V6C0 7.10301 0.896953 8.00002 2.00002 8.00002H3.89016L2.53955 14.7534L1.58592 15.7071C1.21336 16.0792 0.999984 16.5948 0.999984 17.1211V21C0.999984 22.103 1.89694 23 3 23H9C10.103 23 11 22.1031 11 21V17.4272C11 16.6645 10.5762 15.979 9.89456 15.6382L8.043 14.7124L8.4712 11.5H9C9.24708 11.5 9.45703 11.3193 9.49416 11.0752L9.79983 9.06342C9.82181 8.91937 9.77981 8.77289 9.68508 8.66255C9.58988 8.55169 9.45117 8.48822 9.30567 8.48822H8.87269L8.93775 7.99992H12.5C12.5807 7.99992 12.654 7.97653 12.7214 7.94269L12.7237 7.94719L14.6182 6.99994H16.5C16.6328 6.99994 16.7598 6.9472 16.8535 6.85345L17.8535 5.85347C17.9473 5.75972 18 5.63278 18 5.49994V4.99992H23.5C23.7764 4.99992 24 4.77628 24 4.49991C24 4.22353 23.7764 3.99998 23.5 3.99998ZM5.49998 6H2.49998C2.22361 6 1.99997 5.77636 1.99997 5.49998C1.99997 5.22361 2.22361 4.99997 2.49998 4.99997H5.49998C5.77636 4.99997 6 5.22361 6 5.49998C6 5.77636 5.77636 6 5.49998 6ZM5.49998 3.99998H2.49998C2.22361 3.99998 1.99997 3.77634 1.99997 3.49997C2.00002 3.22364 2.22366 3 2.49998 3H5.49998C5.77636 3 6 3.22364 6 3.50001C6 3.77634 5.77636 3.99998 5.49998 3.99998Z"
      fill="#007BFF"
    />
  </svg>
);

export const ElectricalRepair = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1763_372)">
      <path
        d="M22.5669 15.6043C21.3323 14.3688 19.6193 13.8454 17.4193 14.435L9.57441 6.58213L9.6781 6.19007C10.1299 4.49479 9.64172 2.67252 8.40441 1.43521C7.1446 0.174411 5.3536 -0.288198 3.65977 0.177083C3.41822 0.243411 3.23021 0.433208 3.16622 0.675411C3.10224 0.917614 3.17241 1.17505 3.34946 1.35219L5.23838 3.24111C5.79061 3.79471 5.78522 4.6813 5.23974 5.22824C4.69857 5.77086 3.78891 5.77002 3.24989 5.2296L1.3606 3.34016C1.18346 3.16293 0.92527 3.09341 0.683067 3.15777C0.440817 3.22208 0.251723 3.41057 0.18563 3.65235C-0.272855 5.32757 0.178176 7.12968 1.44404 8.39554C2.67807 9.63046 4.38896 10.1557 6.59025 9.56488L14.4358 17.4178C13.8503 19.6171 14.3553 21.3135 15.6065 22.5647C16.8679 23.827 18.6597 24.2862 20.3498 23.8225C20.5914 23.7562 20.7795 23.5663 20.8435 23.3241C20.9076 23.0819 20.8374 22.8245 20.6603 22.6473L18.7718 20.7588C18.2196 20.2052 18.225 19.3185 18.7704 18.7716C19.3184 18.2265 20.226 18.2352 20.7603 18.7709L22.6497 20.6599C22.8269 20.837 23.085 20.9065 23.3272 20.8422C23.5694 20.7778 23.7585 20.5894 23.8246 20.3477C24.2831 18.6727 23.8321 16.8702 22.5669 15.6043Z"
        fill="#007BFF"
      />
      <path
        d="M7.52593 12.4961L0.82318 19.1997C-0.273742 20.2966 -0.273742 22.0804 0.82318 23.1773C1.9201 24.2742 3.70388 24.2742 4.80076 23.1773L11.5034 16.4739L7.52593 12.4961ZM4.1402 20.9952C3.86551 21.2699 3.42066 21.2699 3.14598 20.9952C2.87134 20.7206 2.87134 20.2756 3.14598 20.001L7.41066 15.7355C7.6853 15.4609 8.13029 15.4609 8.40488 15.7355C8.67952 16.0102 8.67952 16.4551 8.40488 16.7297L4.1402 20.9952Z"
        fill="#007BFF"
      />
      <path
        d="M23.7938 1.41812L22.5816 0.205976C22.3535 -0.0221649 21.9994 -0.0657586 21.7228 0.100132L17.994 2.33715C17.6017 2.57251 17.5351 3.11377 17.8585 3.43726L18.1553 3.73398L13.4219 8.44805L15.411 10.4372L20.1445 5.72312L20.5625 6.14129C20.886 6.46468 21.4273 6.39812 21.6626 6.00577L23.8997 2.27701C24.0655 2.0003 24.0219 1.64626 23.7938 1.41812Z"
        fill="#007BFF"
      />
    </g>
    <defs>
      <clipPath id="clip0_1763_372">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const GasLine = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1763_148)">
      <path
        d="M22.7814 17.325C22.7814 16.1062 22.7861 14.9344 22.7814 13.7672C22.7767 13.0172 22.3127 12.5578 21.558 12.539C21.1924 12.5297 20.8221 12.5297 20.4564 12.539C19.8236 12.5578 19.3361 12.975 19.2658 13.5469C19.1955 14.1187 19.4392 14.5359 19.9642 14.7703C20.0721 14.8172 20.1892 14.8453 20.3111 14.8406H20.4705V17.3437H3.5158V14.8359H3.67518C3.82986 14.8406 3.98455 14.8031 4.12518 14.7328C4.54705 14.5078 4.76736 14.1047 4.72518 13.589C4.67361 13.0172 4.20486 12.5672 3.63299 12.539C3.26736 12.5156 2.89705 12.525 2.53143 12.5297C1.65018 12.539 1.21424 12.9797 1.20955 13.8609C1.20486 14.9953 1.20955 16.1297 1.20955 17.2875C0.0142377 17.6812 -0.0279497 17.925 0.0142378 19.4203C0.0236128 19.7719 0.0189253 20.1281 0.00955026 20.4797C-0.0279497 21.7312 0.3283 22.1344 1.52361 22.139H22.4767C22.5939 22.139 22.7111 22.1437 22.8283 22.139C23.5314 22.0969 23.9721 21.6562 23.9861 20.9484C24.0002 20.3297 23.958 19.7109 23.9955 19.0922C24.0471 18.1828 23.8596 17.4562 22.7814 17.325ZM7.1908 20.9672C6.45955 20.9719 5.94861 20.4844 5.93455 19.7765C5.92049 19.0453 6.4408 18.5297 7.1908 18.5344C7.91736 18.539 8.42361 19.0406 8.42361 19.7531C8.42361 20.4656 7.91736 20.9672 7.1908 20.9672ZM11.9486 20.9672C11.2314 20.9578 10.7299 20.4375 10.7439 19.7203C10.758 19.0031 11.2689 18.5297 12.0049 18.5344C12.7314 18.539 13.233 19.0406 13.233 19.7531C13.233 20.4844 12.7127 20.9812 11.9486 20.9672ZM16.8002 20.9672C16.0736 20.9672 15.5627 20.4703 15.558 19.7578C15.5533 19.0265 16.0736 18.525 16.833 18.5344C17.5549 18.5437 18.0564 19.0547 18.0471 19.7672C18.0424 20.4844 17.5314 20.9719 16.8002 20.9672Z"
        fill="#007BFF"
      />
      <path
        d="M12.0198 16.2187C11.5025 16.2187 10.9853 16.1594 10.4788 16.0517C9.12643 15.7554 7.90336 15.0336 6.92814 13.9616C5.96908 12.9112 5.34408 11.5968 5.13395 10.1854C4.97231 9.12962 5.08546 8.05226 5.468 7.05031C6.31391 4.8471 7.72556 2.85936 10.0424 0.602285L10.468 0.1875L13.2698 3.31724L14.8485 1.67426L15.2579 2.11059C15.3334 2.1914 15.4034 2.26681 15.4735 2.33684C15.6243 2.49306 15.7644 2.64389 15.9045 2.80011C16.9983 4.01214 17.8442 5.40194 18.4907 7.0557C18.9002 8.09535 19.0295 9.15656 18.8733 10.2016C18.7278 11.1551 18.3452 12.1247 17.731 13.0835C16.4918 15.0444 14.3366 16.2295 12.0198 16.2187ZM10.2902 6.59782C9.90769 7.11495 9.54131 7.61054 9.23958 8.12229C8.49604 9.39358 8.88936 10.9881 10.1501 11.8284C10.6836 12.1839 11.3571 12.3779 12.0467 12.3779C12.7364 12.3779 13.3991 12.1839 13.9163 11.8338C14.7676 11.2574 15.037 10.5033 15.1071 9.97535C15.1825 9.37203 15.0801 8.76332 14.8215 8.21386L13.2267 10.0131L10.4034 6.4416L10.2902 6.59782Z"
        fill="#007BFF"
      />
    </g>
    <defs>
      <clipPath id="clip0_1763_148">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Generator = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1763_363)">
      <path
        d="M22.2695 9.62347C22.0065 8.48236 21.5616 7.40771 20.9421 6.41821L21.8342 4.9303L19.0697 2.16577L17.5818 3.05786C16.5923 2.43842 15.5176 1.99347 14.3765 1.73053L13.9556 0H10.0444L9.62347 1.73053C8.48236 1.99347 7.40771 2.43842 6.41821 3.05786L4.9303 2.16577L2.16577 4.9303L3.05786 6.41821C2.43842 7.40771 1.99347 8.48236 1.73053 9.62347L0 10.0444V13.9556L1.73053 14.3765C1.99347 15.5176 2.43842 16.5923 3.05786 17.5818L2.16577 19.0697L4.9303 21.8342L6.41821 20.9421C7.40771 21.5616 8.48236 22.0065 9.62347 22.2695L10.0444 24H13.9556L14.3765 22.2695C15.5176 22.0065 16.5923 21.5616 17.5818 20.9421L19.0697 21.8342L21.8342 19.0697L20.9421 17.5818C21.5616 16.5923 22.0065 15.5176 22.2695 14.3765L24 13.9556V10.0444L22.2695 9.62347ZM12 19.7344C7.73529 19.7344 4.26562 16.2647 4.26562 12C4.26562 7.73529 7.73529 4.26562 12 4.26562C16.2647 4.26562 19.7344 7.73529 19.7344 12C19.7344 16.2647 16.2647 19.7344 12 19.7344Z"
        fill="#007BFF"
      />
      <path
        d="M12.8314 4.5L6.2998 14.5172H11.1682V19.5L17.6998 9.48281H12.8314V4.5Z"
        fill="#007BFF"
      />
    </g>
    <defs>
      <clipPath id="clip0_1763_363">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const HvacInstallation = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1763_599)">
      <path
        d="M18.923 10.2692H5.07686L4.24609 13.9615H19.7538L18.923 10.2692Z"
        fill="#007BFF"
      />
      <path
        d="M21.9231 3.11542H2.07694C0.931687 3.11542 0 4.04711 0 5.19231V11.8846C0 13.0298 0.931687 13.9615 2.07694 13.9615H2.82694L3.84769 9.42498C3.91875 9.10904 4.1993 8.88461 4.52311 8.88461H19.4769C19.8007 8.88461 20.0813 9.10904 20.1524 9.42498L21.1731 13.9615H21.9231C23.0683 13.9615 24 13.0299 24 11.8846V5.19231C24 4.04711 23.0683 3.11542 21.9231 3.11542ZM15.6923 7.96154H14.7692C14.3869 7.96154 14.0769 7.65156 14.0769 7.26925C14.0769 6.88693 14.3869 6.57695 14.7692 6.57695H15.6923C16.0747 6.57695 16.3846 6.88693 16.3846 7.26925C16.3846 7.65156 16.0747 7.96154 15.6923 7.96154ZM18.9231 7.96154H18C17.6176 7.96154 17.3077 7.65156 17.3077 7.26925C17.3077 6.88693 17.6177 6.57695 18 6.57695H18.9231C19.3054 6.57695 19.6154 6.88693 19.6154 7.26925C19.6154 7.65156 19.3054 7.96154 18.9231 7.96154Z"
        fill="#007BFF"
      />
      <path
        d="M12.4617 17.1152C12.4617 16.9224 12.4977 16.8625 12.5938 16.7023C12.725 16.4837 12.9233 16.1533 12.9233 15.5769C12.9233 15.1946 12.6133 14.8846 12.231 14.8846C11.8487 14.8846 11.5387 15.1946 11.5387 15.5769C11.5387 15.7697 11.5027 15.8297 11.4066 15.9899C11.2754 16.2085 11.0771 16.5389 11.0771 17.1152C11.0771 17.6916 11.2754 18.022 11.4065 18.2407C11.5027 18.401 11.5387 18.4609 11.5387 18.6538C11.5387 18.8466 11.5027 18.9067 11.4065 19.0668C11.2754 19.2855 11.0771 19.6159 11.0771 20.1923C11.0771 20.5747 11.3871 20.8846 11.7694 20.8846C12.1518 20.8846 12.4617 20.5746 12.4617 20.1923C12.4617 19.9994 12.4977 19.9394 12.5939 19.7792C12.725 19.5606 12.9233 19.2302 12.9233 18.6538C12.9233 18.0773 12.725 17.747 12.5939 17.5283C12.4977 17.3681 12.4617 17.3081 12.4617 17.1152Z"
        fill="#007BFF"
      />
      <path
        d="M8.76936 17.1152C8.76936 16.9224 8.80531 16.8625 8.90145 16.7023C9.03266 16.4837 9.23089 16.1533 9.23089 15.5769C9.23089 15.1946 8.92091 14.8846 8.53859 14.8846C8.15628 14.8846 7.8463 15.1946 7.8463 15.5769C7.8463 15.7697 7.81034 15.8297 7.7142 15.9899C7.583 16.2085 7.38477 16.5389 7.38477 17.1152C7.38477 17.6916 7.583 18.022 7.71416 18.2407C7.8103 18.401 7.8463 18.4609 7.8463 18.6538C7.8463 18.8466 7.81034 18.9067 7.71416 19.0668C7.583 19.2855 7.38477 19.6159 7.38477 20.1923C7.38477 20.5747 7.69475 20.8846 8.07706 20.8846C8.45938 20.8846 8.76936 20.5746 8.76936 20.1923C8.76936 19.9994 8.80531 19.9394 8.9015 19.7792C9.03266 19.5606 9.23089 19.2302 9.23089 18.6538C9.23089 18.0773 9.03266 17.747 8.9015 17.5283C8.80536 17.3681 8.76936 17.3081 8.76936 17.1152Z"
        fill="#007BFF"
      />
      <path
        d="M16.1536 17.1152C16.1536 16.9224 16.1896 16.8625 16.2857 16.7023C16.4169 16.4837 16.6152 16.1533 16.6152 15.5769C16.6152 15.1946 16.3052 14.8846 15.9229 14.8846C15.5406 14.8846 15.2306 15.1946 15.2306 15.5769C15.2306 15.7697 15.1946 15.8297 15.0985 15.9899C14.9673 16.2085 14.769 16.5389 14.769 17.1152C14.769 17.6916 14.9673 18.022 15.0984 18.2407C15.1946 18.401 15.2306 18.4609 15.2306 18.6538C15.2306 18.8466 15.1946 18.9067 15.0984 19.0668C14.9673 19.2855 14.769 19.6159 14.769 20.1923C14.769 20.5747 15.079 20.8846 15.4613 20.8846C15.8437 20.8846 16.1536 20.5746 16.1536 20.1923C16.1536 19.9994 16.1896 19.9394 16.2858 19.7792C16.4169 19.5606 16.6152 19.2302 16.6152 18.6538C16.6152 18.0773 16.4169 17.747 16.2858 17.5283C16.1896 17.3681 16.1536 17.3081 16.1536 17.1152Z"
        fill="#007BFF"
      />
    </g>
    <defs>
      <clipPath id="clip0_1763_599">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const HvacRepair = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1763_342)">
      <path
        d="M21.3816 12.3273C21.3816 12.5091 21.2362 12.6545 21.0907 12.6909L19.2725 13.0182C19.1635 13.3818 19.0544 13.7091 18.9089 14.0727C18.8725 14.1818 18.7635 14.2545 18.6544 14.2909C18.5453 14.3273 18.3998 14.2909 18.3271 14.1818L16.6907 12.5454C16.5816 12.4727 16.5453 12.3273 16.5816 12.2182C17.5271 8.39999 14.618 4.76362 10.7635 4.76362C5.49073 4.76362 2.76346 11.2 6.54528 14.9818C8.03619 16.4727 10.1816 17.0545 12.218 16.5454C12.3271 16.5091 12.4725 16.5454 12.5816 16.6545L14.218 18.2909C14.2907 18.3636 14.3271 18.5091 14.3271 18.6182C14.2907 18.7273 14.218 18.8364 14.1089 18.8727C13.7816 19.0182 13.4544 19.1273 13.1271 19.2L12.7998 21.0182C12.7635 21.2 12.618 21.3091 12.4362 21.3091H9.23619C9.05437 21.3091 8.90891 21.2 8.87255 21.0182L8.54528 19.2C7.78164 19.0182 7.09073 18.7273 6.43619 18.3273L4.90891 19.3818C4.76346 19.4909 4.58164 19.4545 4.43619 19.3454L2.18164 17.1636C2.07255 17.0545 2.03619 16.8364 2.14528 16.6909L3.19982 15.1636C2.83619 14.5454 2.50891 13.8182 2.3271 13.0909L0.47255 12.7636C0.290732 12.7273 0.181641 12.5818 0.181641 12.4V9.19999C0.181641 9.01817 0.327095 8.87272 0.47255 8.83635L2.29073 8.50908C2.47255 7.78181 2.76346 7.05453 3.16346 6.39999L2.10891 4.87272C1.99982 4.72726 2.03619 4.54544 2.14528 4.39999L4.39982 2.18181C4.50891 2.07272 4.72709 2.03635 4.87255 2.14544L6.39982 3.19999C7.05437 2.83635 7.74528 2.50908 8.47255 2.32726L8.79982 0.509079C8.83619 0.327261 8.98164 0.21817 9.16346 0.21817H12.3635C12.5453 0.21817 12.6907 0.363625 12.7271 0.509079L13.0544 2.32726C13.7816 2.50908 14.5089 2.79999 15.1635 3.19999L16.6907 2.14544C16.8362 2.03635 17.018 2.07272 17.1635 2.18181L19.418 4.43635C19.5635 4.54544 19.5635 4.76362 19.4544 4.90908L18.3998 6.43635C18.7635 7.0909 19.0907 7.78181 19.2725 8.54544L21.0907 8.87272C21.2725 8.90908 21.3816 9.05453 21.3816 9.23635V12.3273Z"
        fill="#007BFF"
      />
      <path
        d="M20.6542 17.6363C19.0906 17.8182 17.7815 19.0545 17.5997 20.6909L12.5815 15.6C12.1815 15.2 11.636 14.9818 11.1269 15.0182C8.10876 15.2727 5.74512 12.2909 6.79967 9.30907C6.90876 9.05452 7.19967 8.98179 7.38149 9.16361L9.59967 11.3818C9.78149 11.5636 10.036 11.5636 10.2179 11.3818L11.4542 10.1454C11.636 9.96361 11.636 9.70907 11.4542 9.52725L9.23603 7.30907C9.05421 7.12725 9.12694 6.79998 9.38149 6.72725C12.2179 5.70907 15.2724 7.99998 15.0178 11.0909C14.9815 11.6363 15.1997 12.1454 15.5997 12.5454L20.6542 17.6363Z"
        fill="#007BFF"
      />
      <path
        d="M23.8178 21.0545C23.8178 19.5273 22.5814 18.3273 21.0542 18.2909C19.5269 18.2909 18.3269 19.5273 18.2905 21.0545C18.2905 22.5818 19.5269 23.8182 21.0542 23.8182C22.5814 23.8182 23.8178 22.5818 23.8178 21.0545ZM21.0905 22.0727C20.5451 22.0727 20.0723 21.6363 20.0723 21.0545C20.0723 20.5091 20.5087 20.0363 21.0905 20.0363C21.636 20.0363 22.0723 20.4727 22.1087 21.0545C22.0723 21.6363 21.636 22.0727 21.0905 22.0727Z"
        fill="#007BFF"
      />
    </g>
    <defs>
      <clipPath id="clip0_1763_342">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Maintenance = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1763_83)">
      <path
        d="M14.7516 12.3514L10.8 16.303L9.24842 14.7514C9.137 14.64 9.00473 14.5517 8.85916 14.4913C8.7136 14.4311 8.55758 14.4 8.40002 14.4C8.24246 14.4 8.08643 14.4311 7.94086 14.4913C7.7953 14.5517 7.66302 14.64 7.55162 14.7514C7.44021 14.8628 7.35183 14.9951 7.29153 15.1406C7.23123 15.2862 7.2002 15.4422 7.2002 15.5998C7.2002 15.7574 7.23123 15.9134 7.29153 16.059C7.35183 16.2046 7.44021 16.3368 7.55162 16.4483L9.95161 18.8483C10.0628 18.96 10.195 19.0488 10.3406 19.1093C10.4862 19.1699 10.6423 19.2011 10.8 19.2011C10.9577 19.2011 11.1138 19.1699 11.2594 19.1093C11.405 19.0488 11.5372 18.96 11.6484 18.8483L16.4485 14.0482C16.5598 13.9368 16.6482 13.8046 16.7085 13.659C16.7688 13.5134 16.7998 13.3574 16.7998 13.1998C16.7998 13.0422 16.7688 12.8862 16.7085 12.7406C16.6482 12.5951 16.5598 12.4628 16.4485 12.3514C16.337 12.24 16.2048 12.1517 16.0592 12.0913C15.9136 12.0311 15.7576 12 15.6 12C15.4424 12 15.2864 12.0311 15.1408 12.0913C14.9953 12.1517 14.863 12.24 14.7516 12.3514Z"
        fill="#007BFF"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.0002 2.4H21.0002C21.9602 2.4 22.8002 3.24 22.8002 4.2V22.2C22.8002 23.16 21.9602 24 21.0002 24H3.0002C2.0402 24 1.2002 23.16 1.2002 22.2V4.2C1.2002 3.24 2.0402 2.4 3.0002 2.4H4.8002V1.2C4.8002 0.537258 5.33746 0 6.0002 0C6.66293 0 7.20019 0.537258 7.20019 1.2V2.4H15.6002V1.2C15.6002 0.537258 16.1374 0 16.8002 0C17.463 0 18.0002 0.537258 18.0002 1.2V2.4ZM20.4002 21.6H3.6002V9.6H20.4002V21.6Z"
        fill="#007BFF"
      />
    </g>
    <defs>
      <clipPath id="clip0_1763_83">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const PlumbingInstallation = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1763_2331)">
      <path
        d="M0 14.0652V19.6902C0 20.0786 0.314758 20.3934 0.703125 20.3934H5.29907V13.3621H0.703125C0.314758 13.3621 0 13.6769 0 14.0652Z"
        fill="#007BFF"
      />
      <path
        d="M14.8126 12.6658V11.4402C14.8126 11.4029 14.8088 11.3666 14.8033 11.3309H9.19696C9.19128 11.3666 9.18762 11.4031 9.18762 11.4402V12.6667L8.1712 13.3621H6.70508V20.3934H8.26733C8.56012 20.3934 8.80072 20.441 9.07172 20.5529C9.24622 20.6248 9.43811 20.7048 9.63531 20.7872C10.2604 21.048 10.9068 21.3179 11.2867 21.451C11.5235 21.5339 11.7617 21.5753 12.0001 21.5753C12.2383 21.5753 12.4766 21.5339 12.7131 21.451C13.1989 21.2807 14.2192 20.8638 14.945 20.5585C15.2202 20.4428 15.4648 20.3934 15.7631 20.3934H17.2988V13.3621H15.829L14.8126 12.6658Z"
        fill="#007BFF"
      />
      <path
        d="M23.2968 13.3621H18.7051V20.3934H23.2968C23.6852 20.3934 23.9999 20.0786 23.9999 19.6902V14.0652C23.9999 13.6769 23.6852 13.3621 23.2968 13.3621Z"
        fill="#007BFF"
      />
      <path
        d="M17.1562 2.4375H6.84375C6.06702 2.4375 5.4375 3.0672 5.4375 3.84375C5.4375 4.6203 6.06702 5.25 6.84375 5.25H17.1562C17.933 5.25 18.5625 4.62048 18.5625 3.84375C18.5625 3.0672 17.933 2.4375 17.1562 2.4375Z"
        fill="#007BFF"
      />
      <path
        d="M10.582 6.04688H13.3945V10.5469H10.582V6.04688Z"
        fill="#007BFF"
      />
    </g>
    <defs>
      <clipPath id="clip0_1763_2331">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const PlumbingRepair = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1763_74)">
      <path
        d="M12.2662 18.7035C12.4278 18.8589 12.4307 19.1164 12.2722 19.2749L11.2039 20.3437C10.7622 20.7853 10.1151 20.8953 9.57176 20.6745C9.30793 20.5673 9.24142 20.2233 9.44274 20.022L11.2297 18.2346C11.3862 18.0782 11.6402 18.0786 11.7964 18.2354C12.0229 18.4628 12.1637 18.6049 12.2662 18.7035Z"
        fill="#007BFF"
      />
      <path
        d="M16.7573 8.72576L16.3414 9.1419C16.1852 9.29822 15.9319 9.29822 15.7756 9.14195L12.4736 5.83999C12.2655 5.63187 12.0171 5.46295 11.7414 5.34618C11.4157 5.20817 11.4234 4.73667 11.7534 4.60905C12.7631 4.21851 13.8784 4.81513 14.1018 5.86949C14.1353 6.02851 14.2593 6.15302 14.4178 6.18653C15.0877 6.32739 15.6204 6.85365 15.764 7.53263C15.7975 7.69124 15.9198 7.81456 16.0784 7.84796C16.3094 7.89667 16.5232 7.99198 16.7055 8.11619C16.9103 8.25591 16.9326 8.55044 16.7573 8.72576Z"
        fill="#007BFF"
      />
      <path
        d="M15.4397 16.986C15.6259 17.1319 15.6459 17.407 15.4818 17.5774C15.0098 18.0675 14.6488 18.5665 13.8833 18.5665C13.1336 18.5665 12.7755 18.0875 12.3612 17.6552C12.2109 17.4983 12.2141 17.2499 12.3677 17.0963L13.5546 15.9443C13.6983 15.8061 13.922 15.7949 14.0789 15.918L15.4397 16.986Z"
        fill="#007BFF"
      />
      <path
        d="M23.2488 8.29779L19.3732 12.1739C19.217 12.3301 18.9637 12.3301 18.8074 12.1739L16.9069 10.2733C16.7507 10.1171 16.7507 9.86381 16.9068 9.7076L18.9185 7.69557C19.0747 7.53936 19.0747 7.28608 18.9184 7.12986L18.5312 6.74262C18.2912 6.50259 18.1277 6.20056 18.0577 5.86952C18.0241 5.71151 17.9006 5.58799 17.7421 5.55449C17.0634 5.41097 16.5439 4.88161 16.399 4.22284C16.362 4.05532 16.237 3.92581 16.0799 3.8923C15.7339 3.8193 15.4219 3.64478 15.1773 3.38775C14.5288 2.70717 14.5528 1.60205 15.2298 0.924477L15.5524 0.601941C16.3555 -0.200647 17.6616 -0.200647 18.4647 0.601941L23.2208 5.35807C24.0675 6.20466 24.0467 7.50095 23.2488 8.29779Z"
        fill="#007BFF"
      />
      <path
        d="M19.9096 14.407L11.9082 6.40561C11.5902 6.08757 11.1512 5.92955 10.7031 5.97106C10.2206 6.01636 9.79965 6.29635 9.58698 6.64163L9.00542 7.61224C8.71438 8.09779 8.69688 8.71086 8.95941 9.21242L9.29145 9.84599C9.46197 10.172 9.40196 10.5651 9.14243 10.8251L1.01453 18.9525C0.455971 19.5111 0.148438 20.2541 0.148438 21.0437C0.148438 22.6926 1.48419 24 3.10626 24C3.86335 24 4.62093 23.712 5.1975 23.1355L13.1924 15.1401C13.4914 14.8415 13.967 14.813 14.2995 15.0736L17.2118 17.3598C17.8104 17.8299 18.668 17.7784 19.2065 17.2398L19.9096 16.5367C20.4961 15.9502 20.4979 14.9953 19.9096 14.407ZM5.79106 20.1142L4.44691 21.4583C3.95101 21.9542 3.14177 21.9559 2.64521 21.4583C2.14816 20.9618 2.14816 20.1537 2.64521 19.6566L3.98936 18.3125C4.48642 17.8154 5.29451 17.8154 5.79106 18.3125C6.28812 18.809 6.28812 19.6171 5.79106 20.1142Z"
        fill="#007BFF"
      />
      <path
        d="M5.36378 19.213C5.36378 19.3345 5.31728 19.456 5.22527 19.548L3.88062 20.8927C3.6961 21.0777 3.39506 21.0777 3.21054 20.8927C3.02552 20.7082 3.02552 20.4071 3.21054 20.2226L4.55519 18.878C4.84647 18.5851 5.36378 18.7848 5.36378 19.213Z"
        fill="#007BFF"
      />
    </g>
    <defs>
      <clipPath id="clip0_1763_74">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Solar = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1763_447)">
      <path
        d="M22.2001 1.4573L22.2053 1.46372C22.2851 1.57186 22.309 1.71145 22.2696 1.83998L21.397 4.71435H17.0659L18.1052 1.28583H21.8573C21.9923 1.28518 22.1197 1.34888 22.2001 1.4573Z"
        fill="#007BFF"
      />
      <path
        d="M7.16328 5.57153H11.196L10.0273 9.42858H5.99414L7.16328 5.57153Z"
        fill="#007BFF"
      />
      <path
        d="M5.09794 9.42858H1.41016L2.57887 5.57153H6.26707L5.09794 9.42858Z"
        fill="#007BFF"
      />
      <path
        d="M12.3511 4.71441L13.3903 1.28589H17.2093L16.17 4.71441H12.3511Z"
        fill="#007BFF"
      />
      <path
        d="M15.9105 5.57153L14.7418 9.42858H10.9229L12.0915 5.57153H15.9105Z"
        fill="#007BFF"
      />
      <path
        d="M11.4556 4.71441H7.42285L8.46168 1.28589H12.4949L11.4556 4.71441Z"
        fill="#007BFF"
      />
      <path
        d="M9.76734 10.2857L8.46837 14.5714H4.43555L5.7341 10.2857H9.76734Z"
        fill="#007BFF"
      />
      <path
        d="M10.6632 10.2857H14.4822L13.1832 14.5714H9.36426L10.6632 10.2857Z"
        fill="#007BFF"
      />
      <path
        d="M15.3776 10.2857H19.7061L18.4997 14.2671C18.4449 14.4478 18.2784 14.5713 18.0895 14.5713H14.0786L15.3776 10.2857Z"
        fill="#007BFF"
      />
      <path
        d="M19.9679 9.42858H15.6372L16.8059 5.57153H21.137L19.9679 9.42858Z"
        fill="#007BFF"
      />
      <path
        d="M3.78601 1.58973C3.84174 1.40978 4.00777 1.28678 4.19616 1.28589H7.56594L6.52712 4.71441H2.83887L3.78601 1.58973Z"
        fill="#007BFF"
      />
      <path
        d="M0.0192673 14.0185L1.15067 10.2857H4.83845L3.53994 14.5714H0.428995C0.293247 14.5715 0.165468 14.5073 0.0845162 14.3983C0.00356448 14.2893 -0.0209507 14.1484 0.0184236 14.0185H0.0192673Z"
        fill="#007BFF"
      />
      <path
        d="M15.1829 20.4427L16.6233 21.0603C16.9387 21.1953 17.1432 21.5054 17.1431 21.8484V22.2856C17.1431 22.5222 16.9513 22.7141 16.7145 22.7141H7.7147C7.47804 22.7141 7.28613 22.5223 7.28613 22.2856V21.8484C7.2859 21.5048 7.49083 21.1943 7.80686 21.0594L9.24557 20.4427C9.87696 20.1729 10.2865 19.5523 10.2861 18.8656V17.5714H14.1432V18.8656C14.142 19.5523 14.5513 20.1731 15.1829 20.4427Z"
        fill="#007BFF"
      />
      <path
        d="M23.9814 3.98155L20.2134 16.4142C20.1574 16.5924 19.9923 16.7138 19.8054 16.7142H2.143C2.01475 16.7158 1.89293 16.6581 1.81301 16.5577L0.90918 15.4285H18.0916C18.6588 15.4308 19.1597 15.0591 19.322 14.5157L22.9828 2.43573L23.905 3.58855C23.9939 3.6989 24.0224 3.84599 23.9814 3.98155Z"
        fill="#007BFF"
      />
    </g>
    <defs>
      <clipPath id="clip0_1763_447">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const WaterLeakRepair = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1763_292)">
      <path
        d="M13.9084 0H12.6425V4.74012L9.41813 6.60211L6.19334 4.74012V0H4.92737L2.38281 5.2393L6.42398 10.5857V24H12.4118V10.5857L16.4535 5.2393L13.9084 0ZM10.1199 17.4667H8.71638V16.0632H10.1199V17.4667ZM10.1199 14.473H8.71638V13.0695H10.1199V14.473ZM10.1199 11.4793H8.71638V10.0758H10.1199V11.4793Z"
        fill="#007BFF"
      />
      <path
        d="M18.2108 14.6433C18.2108 14.6433 14.8047 18.666 14.8047 20.5471C14.8047 22.4283 16.3296 23.9532 18.2108 23.9532C20.0919 23.9532 21.6169 22.4283 21.6169 20.5471C21.6169 18.666 18.2108 14.6433 18.2108 14.6433Z"
        fill="#007BFF"
      />
    </g>
    <defs>
      <clipPath id="clip0_1763_292">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
